import React, { Component } from "react";
import { getViewPatientData } from "../../lib";
import Loader from "../Loader";

class AISummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null,
            summary: props.summary || "",
            generatedAt: props.generatedAt || "",
            model: props.model || "",
        };
    }

    componentDidMount() {
        if (this.props.mrn) {
            this.fetchAISummary(this.props.mrn);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.mrn && this.props.mrn !== prevProps.mrn) {
            this.fetchAISummary(this.props.mrn);
        }
    }

    getSummaryFromResponse = (data) => {
        if (!data) return "";

        const row = Array.isArray(data?.data) ? data.data[0] : data;
        return (
            row?.summary_text ||
            row?.summary ||
            row?.ai_summary ||
            row?.AISummary ||
            row?.message ||
            ""
        );
    };

    fetchAISummary = async (mrn) => {
        const { settings } = this.props;
        const baseUrl = settings?.server?.baseUrl;

        if (!baseUrl) {
            this.setState({ error: "Missing server configuration." });
            return;
        }

        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${baseUrl}/fetch/patient_summary?memberid=${encodeURIComponent(mrn)}`;
            const data = await getViewPatientData({
                url: apiUrl,
                server: settings.server,
            });

            this.setState({
                loading: false,
                summary: this.getSummaryFromResponse(data),
                generatedAt: data?.generatedAt || data?.generated_at || "",
                model: data?.model || "",
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error?.message || "Failed to load AI summary.",
            });
        }
    };

    render() {
        const { loading, error, summary } = this.state;

        return (
            <div style={styles.wrapper}>
                <div style={styles.header}>
                    <div style={styles.headerLeft}>
                        <span style={styles.sparkIcon}>*</span>
                        <span style={styles.headerTitle}>AI Patient Summary</span>
                    </div>
                </div>

                <div style={styles.body}>
                    {loading ? (
                        <div style={styles.loaderWrap}>
                            <Loader />
                        </div>
                    ) : error ? (
                        <p style={styles.errorText}>{error}</p>
                    ) : (
                        <p style={styles.paragraph}>
                            {summary || "No AI summary available for this patient."}
                        </p>
                    )}
                </div>
            </div>
        );
    }
}

const styles = {
    wrapper: {
        border: "1px solid #d0d7de",
        borderRadius: "8px",
        overflow: "hidden",
        fontFamily: "'Georgia', 'Times New Roman', serif",
        backgroundColor: "#fafbfc",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 16px",
        backgroundColor: "#f0f4f8",
        borderBottom: "1px solid #d0d7de",
    },
    headerLeft: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    sparkIcon: {
        fontSize: "13px",
        color: "#2563eb",
    },
    headerTitle: {
        fontSize: "13px",
        fontWeight: "700",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#1e293b",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
    },
    badge: {
        fontSize: "10px",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        fontWeight: "600",
        color: "#2563eb",
        backgroundColor: "#dbeafe",
        padding: "2px 7px",
        borderRadius: "99px",
        letterSpacing: "0.04em",
        textTransform: "uppercase",
    },
    headerRight: {},
    meta: {
        fontSize: "11px",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#64748b",
    },
    body: {
        padding: "18px 20px 14px",
    },
    loaderWrap: {
        padding: "20px 0",
        textAlign: "center",
    },
    paragraph: {
        fontSize: "14.5px",
        lineHeight: "1.75",
        color: "#1e293b",
        margin: "0 0 12px 0",
    },
    errorText: {
        fontSize: "13px",
        color: "#b91c1c",
        margin: 0,
    },
    footer: {
        display: "flex",
        alignItems: "flex-start",
        gap: "7px",
        padding: "10px 16px",
        backgroundColor: "#fffbeb",
        borderTop: "1px solid #fde68a",
    },
    warningIcon: {
        fontSize: "12px",
        color: "#b45309",
        marginTop: "1px",
        flexShrink: 0,
    },
    disclaimer: {
        fontSize: "11.5px",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#92400e",
        lineHeight: "1.5",
    },
};

export default AISummary;
